import { render, staticRenderFns } from "./NavPanel.vue?vue&type=template&id=4a0e27b8&scoped=true&"
import script from "./NavPanel.vue?vue&type=script&lang=js&"
export * from "./NavPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e27b8",
  null
  
)

export default component.exports